import routerOptions0 from "/builds/vapebay/commerce-frontend/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}